var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<button title=\"drucken\" ng-click=\"vm.printDiv()\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-print\"></i></button>");;return buf.join("");
}